import { Box, Checkbox, Icon, IconButton, Td, Tr } from "@chakra-ui/react";
import { t } from "i18next";
import { Dispatch, SetStateAction, useState } from "react";
import { FaRegComments } from "react-icons/fa";
import { ReceivedBseBidDto, WinningProductGroupBidsDto } from "../../../../../autogen/bff-api";
import { Message } from "../../../../../common/ConversationModal";
import { Product, ProductDraft, ProductGroup } from "../../../../../common/types";
import { getAwardedProductPrice, getBestProductPrice } from "./BidEvaluationUtils";
import { SelectPriceCell } from "./SelectPriceCell";

export const EvaluationRow = ({
  product,
  group,
  bids,
  selectedBids,
  setProductConversation,
}: {
  product: Product;
  group: ProductGroup;
  bids?: ReceivedBseBidDto[];
  selectedBids: WinningProductGroupBidsDto[];
  setProductConversation: Dispatch<
    SetStateAction<
      | {
          conversation: Message[];
          title: string;
          productGroup: ProductGroup;
          product: Product | ProductDraft;
        }
      | undefined
    >
  >;
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>();

  return (
    <Tr key={product.id}>
      {group.productFields
        .filter((field) => field.populatedBy === "Buyer")
        .map((field) => (
          <Td key={field.name} position={"relative"} minWidth="40" verticalAlign={"top"} p="1">
            {field.type === "Boolean" ? (
              <Checkbox
                isDisabled={true}
                isChecked={!!product.productFields.find((f) => f.name === field.name)?.value}
              />
            ) : (
              <Box
                as={"pre"}
                fontFamily={"body"}
                whiteSpace={"pre-wrap"}
                maxHeight={isExpanded ? "none" : "10"}
                overflow={"hidden"}
                cursor={"pointer"}
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {product.productFields.find((f) => f.name === field.name)?.value}
              </Box>
            )}
            <Box
              width={"full"}
              position={"absolute"}
              top="5"
              bottom="0"
              left="0"
              bgGradient={isExpanded ? "" : "linear(to bottom, transparent, smBackground)"}
              pointerEvents={"none"}
            ></Box>
          </Td>
        ))}
      <Td minWidth="40" verticalAlign={"top"} p="4">
        {product.quantity.value}
      </Td>
      {bids?.map((bid) => (
        <SelectPriceCell
          key={bid.id}
          bid={bid}
          bids={bids}
          product={product as Product}
          group={group}
          selectedBids={selectedBids}
        />
      ))}
      {
        <Td textAlign={"right"} verticalAlign={"top"} p="4">
          {getBestProductPrice({
            productId: product.id,
            group,
            bids: bids ?? [],
          })?.toLocaleString()}
        </Td>
      }
      <Td textAlign={"right"} verticalAlign={"top"} fontWeight={"bold"} p="4">
        {getAwardedProductPrice({
          group,
          productId: product.id,
          bids: bids ?? [],
          selectedBids,
        })
          ? getAwardedProductPrice({
              group,
              productId: product.id,
              bids: bids ?? [],
              selectedBids,
            })?.toLocaleString()
          : ""}
      </Td>
      <Td verticalAlign={"top"} p="1">
        <IconButton
          variant={"outline"}
          aria-label="Product comments"
          icon={<Icon as={FaRegComments} />}
          onClick={() =>
            setProductConversation({
              conversation:
                product.conversation?.map((msg, i) => ({
                  id: `${i}`,
                  value: msg.comment,
                  createdBy: `${msg.createdBy?.firstName} ${msg.createdBy?.lastName}`,
                  createdAt: msg.createdAt,
                })) ?? [],
              title: `${t("Conversation regarding product")} - ${product.productFields[0].value}`,
              product,
              productGroup: group,
            })
          }
        />
      </Td>
    </Tr>
  );
};
